import type { PropsWithChildren } from 'react';
import { Dialog, type DialogContentProps } from '@tamagui/dialog';

type ModalContentProps = {
  testID: string;
} & Omit<
  DialogContentProps,
  | 'children'
  | 'elevate'
  | 'animateOnly'
  | 'animation'
  | 'enterStyle'
  | 'exitStyle'
>;

export const ModalContent = ({
  testID,
  children,
  ...dialogContentProps
}: PropsWithChildren<ModalContentProps>) => (
  <Dialog.Content
    testID={testID}
    elevate
    animateOnly={['transform', 'opacity']}
    animation={['quick', { opacity: { overshootClamping: true } }]}
    enterStyle={{ x: 0, y: 20, opacity: 0 }}
    exitStyle={{ x: 0, y: 10, opacity: 0, scale: 0.95 }}
    padding="$6"
    borderWidth="$0"
    width="100%"
    borderRadius="$1.5"
    backgroundColor="$surface.background"
    {...dialogContentProps}
  >
    {children}
  </Dialog.Content>
);
